<template>
  <ion-app>
    <Suspense>
      <template #default>
        <div>
          <div v-if="backdrop.show.value">
            <ion-spinner name="lines" color="light" class="spinner-backdrop"></ion-spinner>
            <ion-backdrop :visible="true"></ion-backdrop>
          </div>
          <MainMenu></MainMenu>
          <AdminTestMenu v-if="true"></AdminTestMenu>
          <TopicMenu v-if="true"></TopicMenu>
          <!--<ion-router-outlet id="main-content"/>  Usa cache en cada pagina, una vez renderizada -->
          <router-view id="main-content"/>
        </div>

      </template>
      <template #fallback>
        <h1>Cargando...</h1>
      </template>
    </Suspense>

  </ion-app>
</template>

<script setup lang="ts">
import {IonApp, IonBackdrop, IonSpinner} from '@ionic/vue';
import MainMenu from "@/components/MainMenu.vue";
import {inject, onMounted, onUnmounted} from "vue";

import AdminTestMenu from "@/components/AdminTestMenu.vue";
import TopicMenu from "@/components/TopicMenu.vue";

const backdrop = inject('backdrop');
const auth = inject('auth') as IAuthPlugin;


const blockClickRight = async (e: MouseEvent) => {
  const config = await auth.getConfig()!;
  if (!config.user.is_admin) {
    e.preventDefault();
  }
}

onMounted(() => {
  window.addEventListener('contextmenu', function (e) {
    blockClickRight(e);
  });
});

onUnmounted(() => {
  window.removeEventListener('contextmenu', function (e) {
    blockClickRight(e);
  });
});

</script>


<style scoped>

ion-backdrop {
  background: var(--ion-color-dark);
  opacity: 0.6;
}

.spinner-backdrop {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  height: 80px;
}
</style>
